// Relatórios de conferência e base do PIS/COFINS (F0h) — só apresentação; as
// regras são do backend (services/relatorios_conferencia.py, codigos_fiscais.py).

// CSV para Excel: ';', UTF-8 com BOM, aspas quando precisa (mesmo formato das
// planilhas do F0a). Montado no navegador: nada é gravado no servidor.
export function paraCsv(colunas, linhas) {
  const cel = (v) => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[";\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const corpo = [colunas.map(cel).join(';'),
    ...(linhas || []).map(l => colunas.map(c => cel(l[c])).join(';'))];
  return '\uFEFF' + corpo.join('\r\n') + '\r\n';
}

export const BASES_PIS_COFINS = [
  { valor: 'receita', rotulo: 'Receita da operação: produtos + frete + seguro + outras − desconto − ICMS destacado (padrão)' },
  { valor: 'vprod_menos_vdesc', rotulo: 'Produtos − desconto (como era antes)' },
];

// Quadro "Pendências por empresa": null = Simples (não se aplica).
export function basePisCofinsPendente(p) {
  return !!p && p.base_pis_cofins === 'confirmar';
}

export function rotuloBasePisCofins(p) {
  if (!p || p.base_pis_cofins === null || p.base_pis_cofins === undefined) return '— (Simples)';
  if (p.base_pis_cofins === 'confirmar') return 'Confirmar base do PIS/COFINS';
  if (p.base_pis_cofins === 'receita') return 'Receita da operação';
  if (p.base_pis_cofins === 'vprod_menos_vdesc') return 'Produtos − desconto';
  return String(p.base_pis_cofins);
}
